import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { OdataResult } from "@shared/models/http/odata-result";
import { PracticeDto } from "@shared/models/http/practice-dto";
import { IEnvironmentConfig } from "@webpack/extra-webpack-types";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class PracticeService {
  private readonly _apiRoot: string;

  private _defaultOptions = {
    withCredentials: true,
  };

  constructor(
    @Inject("ENV") private _env: IEnvironmentConfig,
    private _http: HttpClient
  ) {
    this._apiRoot = `${this._env.apiGatewayUrl}/odata/Practice`;
  }

  public get(practiceId: number): Observable<PracticeDto> {
    return this._http
      .get<OdataResult<{ Name: string; PracticeId: number }[]>>(this._apiRoot, {
        ...this._defaultOptions,
        params: new HttpParams({
          fromObject: {
            $select: "PracticeId,Name",
            $filter: `PracticeId eq ${practiceId}`,
          },
        }),
      })
      .pipe(
        map((v) => ({
          id: v.value[0].PracticeId,
          name: v.value[0].Name,
        }))
      );
  }
}
